export default [
  {
    value: 'img',
    text: 'Медиа',
    width: 300,
    type: 'media',
    description: ''
  },
  {
    value: 'fileName',
    text: 'Имя файла',
    type: 'string',
    description: ''
  },
  {
    value: 'type',
    text: 'Тип',
    width: 120,
    type: 'string',
    description: ''
  },
  {
    value: 'size',
    text: 'Размер',
    width: 160,
    type: 'number',
    description: ''
  },
  {
    value: 'createdAt',
    text: 'Дата',
    width: 180,
    type: 'date',
    description: ''
  },
  {
    value: 'actions',
    text: 'Действия',
    width: 105,
    align: 'end',
    type: 'actions',
    sortable: false,
    description: ''
  }
]
